import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { acPopVizibil } from '../actions/acPopVizibil'
import { acWidgetToggle } from '../actions/acWidgetToggle'

class WidgetPromotieLastResults extends React.Component {

    constructor() {
        super();
        this.state = {
            nrRows: 3,
        }
    }
    leaderboard(val) {
        var tr = [];
        for (var i = 0; i < this.state.nrRows; i++) {
            tr.push(
                <tr key={i}>
                    <td>{this.top3(i + 1)}</td>
                    <td>{val[i].username}</td>
                    <td>{val[i].points}</td>
                    <td>{val[i].prize + ' RON'}</td>
                </tr>
            )
        }
        tr.push(
            <tr key="lastRow">
                <td colSpan="4" className="dots">...</td>
            </tr>
        )
        return tr
    }
    top3(val) {
        if (val <= 3) {
            return <img src={"img/icon/ic" + val + ".png"} alt="" />
        } else {
            return val
        }
    }
    prize(val) {
        if (val > 0) {
            return val
        } else {
            return '-'
        }
    }
    clasament(e) {
        if (this.props.conSizeChange.appW < 1000 && this.props.widgetToggle) {
            this.props.acWidgetToggle(!this.props.widgetToggle)
        }
        this.props.acPopVizibil({
            vizibil: true,
            position: { x: 'auto', y: 50 },
            info: { type: 'clasamentWidgetLastResults' }
        })
        e.stopPropagation();
    }
    toggleMobile() {
        if (this.props.widgetToggle === true) {
            return 'mob'
        } else {
            return ''
        }
    }
    render() {
        // console.log('wigetPromotie last', this.props.widgetPromotie.lastResults, this.props.widgetPromotie.lastResults.length);
        if (this.props.multiLang) {
            return (
                <div className={"widget-promotion WidgetPromotieLastResults " + this.toggleMobile()}>
                    <div className="module-header">
                        {this.props.multiLang.clasamentSaptAnterioara.txt}
                    </div>
                    <div className="con-leaderboard">
                        <table>
                            <thead>
                                <tr>
                                    <th>{this.props.multiLang.loc.txt}</th>
                                    <th>{this.props.multiLang.user.txt}</th>
                                    <th>{this.props.multiLang.points.txt}</th>
                                    <th>{this.props.multiLang.prize.txt}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.leaderboard(this.props.widgetPromotie.lastResults)}
                            </tbody>
                        </table>
                    </div>
                    <div onClick={this.clasament.bind(this)} className="leaderboard-footer">
                        <div><img src={"img/icon/top.png"} alt="" />
                        <span>
                            {"Vezi clasament anterior"}
                            {/* {this.props.multiLang.veziClasament.txt} */}
                        </span></div>
                    </div>
                </div>
            )
        } else {
            return <div></div>
        }
    }
}

function mapStateToProps(state) {
    return {
        widgetPromotie: state.widgetPromotie,
        defaultVal: state.defaultVal,
        multiLang: state.multiLang,
        appProps: state.appProps,
        conSizeChange: state.conSizeChange,
        widgetToggle: state.widgetToggle
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acPopVizibil: acPopVizibil,
        acWidgetToggle: acWidgetToggle,
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(WidgetPromotieLastResults);

// export default TopWiners